export default {
  potential: {
    banner: '赝势',
    title: '赝势简介',
    titleP1:`
    目前，我们提供两种类型的赝势：模守恒赝势和超软赝势。这些赝势的格式采用的是
    `,
    titleP1_2: '的UPF2.0格式。我们提供的赝势库文件都是通过整理其他的开源库而来。',
    titleP2: '对于模守恒赝势（Norm-Conserving Pseudopotential），我们提供了三种类型：',
    titleP2_2: '和',
    titleP2_4: '。其中SG15和PD03赝势都是用',
    titleP2_5: `
    （Optimized Norm-Conservinng Vanderbilt PSeudopotential）产生的。SG15和PD03都是最近开发的模守恒赝势，
    相比以往旧的赝势，这些赝势更加精确。但是由于部分赝势包含semicores，因此需要更大截断能保证收敛。
    这也减慢了计算速度、增加了内存需求。FHI相比上面两种赝势较“软”，但是精度也相对低一些。
    `,
    titleP3: '对于超软赝势（Ultrasoft Pseudopotnetial），我们也提供了两种类型：USPP-SOFT和',
    titleP3_2: `
    。GBRV赝势也因为semicores导致截断能较大，但计算更加精确；而相对的USPP-SOFT的截断能更小一些，精度略微低。
    `,
    titleP4: '关于上面这些赝势的性能比较可以参考这篇文献：',
    titleP5: '除此之外，我们还提供了一套SOC赝势用于非线性计算、一套H的分数赝势用于H钝化计算。',
    titleP6: `
    20221123之后的PWmat版本支持高斯基组，我们提供高斯基组需要的BASIS和赝势，GTH_BASIS_SETS , GTH_POTENTIALS，BASIS_MOLOPT。此外，用户也可以从
    `,
    titleP6_2: '网站获取。',
    part2: '下载链接',
    part3: '使用说明',
    part3P1: '对于超软赝势，要求ECUT2L=4*ECUT2.',
    part3P2: `
    对于大多数计算，设置ECUT2=2*ECUT就足够了，如果要求更高的计算精度，可以设置ECUT2=4*ECUT。对于镧系元素建议设置Ecut等于90~120Ryd，Ecut2=4*Ecut。
    `,
    part3p3: `
    对于原子弛豫，如果发现弛豫的力不再减小，也可以设置ECUT2=4*ECUT，对于更好弛豫效果（当然计算资源占用更大）可以设置ECUT2=4*ECUT，ECUT2L=4*ECUT2。
    `,
    part3P4: '对于在弛豫计算之前考虑了EGG_HEAD修正，也可以设置ECUT2=4*ECUT，ECUT2L=ECUT2。',
    part3P5: '对于晶格弛豫，为了得到更合理的晶格，需要更大截断能，一般比默认的ECUT大10~20Ry就足够了。',
    part3P6: `
    其他类型的计算，例如分子动力学计算、能带计算，可以适当的调整ECUT、ECUT2和ECUT2L的设置（减小ECUT值，减小ECUT、ECUT2、ECUT2L的倍数关系)。
    `,
    part3P7: `
    对于分数氢赝势，区分不同氢的方法主要是修改atom.config中的相对原子序数。
    无论是正常的氢赝势还是分数氢赝势，一般情况下它们的原子序数都是1。而PWmat主要是通过原子序数来对不同的赝势和原子进行匹配的。
    因此为了能够区分开正常的氢赝势和分数氢赝势，需要按照如下规则在atom.config文件中设置氢的原子序数：
    `,
    part3P8: `
    109 --- H_0.25.SG15.PBE.UPF意义是在atom.config中109会对应H_0.25的赝势。在解压的H.zip文件夹中有一个README.TXT说明文件供参考，也有一个example文件夹供测试。
    `,
  }
}